import { ListType } from "@/types/lists.types";

export const LIST_TYPES = {
  [ListType.FAVORITES]: {
    value: ListType.FAVORITES,
    label: "Favorites",
    description: "Your favorite restaurants",
    color: "border-border bg-transparent text-foreground",
  },
  [ListType.WANT_TO_TRY]: {
    value: ListType.WANT_TO_TRY,
    label: "Want to Try",
    description: "Restaurants you want to visit",
    color: "border-border bg-transparent text-foreground",
  },
  [ListType.VISITED]: {
    value: ListType.VISITED,
    label: "Visited",
    description: "Restaurants you've been to",
    color: "border-border bg-transparent text-foreground",
  },
  [ListType.FEATURED]: {
    value: ListType.FEATURED,
    label: "Featured",
    description: "",
    color: "border-border bg-transparent text-foreground",
  },
  [ListType.CUSTOM]: {
    value: ListType.CUSTOM,
    label: "Custom",
    description: "",
    color: "border-border bg-transparent text-foreground",
  },
} as const;

export const LIST_TYPE_OPTIONS = Object.values(LIST_TYPES);

export const getListTypeInfo = (listType: string) => {
  return LIST_TYPES[listType as ListType] || LIST_TYPES[ListType.CUSTOM];
};